var $0072de3aa375a1e7$exports = {};
var $0072de3aa375a1e7$var$Pokedex = Panels.App.extend({
    topbarView: Topbar,
    backButtonPrefix: '<i class="fa fa-chevron-left"></i> ',
    states2: {
        "pokemon/:pokemon": PokedexPokemonPanel,
        "moves/:move": PokedexMovePanel,
        "items/:item": PokedexItemPanel,
        "abilities/:ability": PokedexAbilityPanel,
        "types/:type": PokedexTypePanel,
        "categories/:category": PokedexCategoryPanel,
        "tags/:tag": PokedexTagPanel,
        "egggroups/:egggroup": PokedexEggGroupPanel,
        "tiers/:tier": PokedexTierPanel,
        "articles/:article": PokedexArticlePanel,
        "": PokedexSearchPanel,
        "pokemon/": PokedexSearchPanel,
        "moves/": PokedexSearchPanel,
        ":q": PokedexSearchPanel
    },
    initialize: function() {
        this.routePanel("*path", PokedexSearchPanel); // catch-all default
        let root = Config.baseurl.slice(1);
        for(var i in this.states2)this.routePanel(root + i, this.states2[i]);
    }
});
var $0072de3aa375a1e7$var$pokedex = new $0072de3aa375a1e7$var$Pokedex();


//# sourceMappingURL=index.b96d8c60.js.map
